import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';
import ClientNav from '@/components/ClientNav';
import { FileText, Download, ExternalLink } from 'lucide-react';
import { format } from 'date-fns';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ClientFiles = () => {
  const { token } = useAuth();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    fetchFiles();
  }, []);

  const fetchFiles = async () => {
    try {
      const response = await axios.get(`${API}/client/files`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFiles(response.data.files);
    } catch (error) {
      console.error('Failed to fetch files:', error);
    }
  };

  return (
    <div className="min-h-screen bg-[#030712]" data-testid="client-files-page">
      <ClientNav />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold font-['Syne'] text-white mb-2" data-testid="files-title">Files</h1>
          <p className="text-slate-400">Access your delivered assets and files</p>
        </div>

        {files.length === 0 ? (
          <div className="bg-slate-950 border border-slate-800 rounded-xl p-12 text-center" data-testid="no-files">
            <FileText className="w-16 h-16 text-slate-700 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-white mb-2">No files yet</h3>
            <p className="text-slate-400">Your delivered files will appear here</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="files-grid">
            {files.map((file) => (
              <div
                key={file.id}
                className="bg-slate-950 border border-slate-800 rounded-xl p-6 hover:border-indigo-500/50 transition-colors"
                data-testid={`file-${file.id}`}
              >
                <div className="w-12 h-12 rounded-lg bg-indigo-500/10 flex items-center justify-center mb-4">
                  <FileText className="text-indigo-400" size={24} />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">{file.name}</h3>
                <p className="text-sm text-slate-400 mb-4">
                  Uploaded: {format(new Date(file.uploaded_at), 'MMM dd, yyyy')}
                </p>
                <a
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 text-indigo-400 hover:text-indigo-300 transition-colors"
                  data-testid={`file-link-${file.id}`}
                >
                  <ExternalLink size={16} />
                  <span className="text-sm font-medium">View File</span>
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientFiles;
